/* Wissenswunderland — assets/wwl.js. The frozen mock's wwl.js (reveal, tabs, scene, ticker, drawer, footer) with the port's additions:
   - every feature initialises per root, so the theme editor can re-run it on shopify:section:load (a root is never initialised twice)
   - card "+" buttons add the real variant through /cart/add.js and open Minimog's cart drawer (fallback: the product page)
   - the drawer keeps focus inside, returns it to the burger and sets aria-expanded
   - reveals run in the theme editor too; selecting a section or block shows it at once
   - the newsletter form is a real Shopify customer form (the mock only confirmed the click), so the mock's initForm is gone
   Vanilla, no dependencies. */
(function () {
  var doc = document, root = doc.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('wwl-js');
  function $$(sel, scope) { return Array.prototype.slice.call((scope || doc).querySelectorAll(sel)); }
  function once(node, key) { if (node['wwl_' + key]) return false; node['wwl_' + key] = true; return true; }

  /* reveal: IntersectionObserver + scroll sweep, so a fast flick never strands a section */
  var pending = [], io = null, swept = false;
  function show(n) { n.classList.add('is-in'); }
  function sweep() {
    var h = window.innerHeight;
    for (var i = pending.length - 1; i >= 0; i--) {
      var r = pending[i].getBoundingClientRect();
      if (r.top < h * 0.92) { show(pending[i]); pending.splice(i, 1); }
    }
  }
  function initReveal(scope) {
    var items = $$('.wwl-r', scope).filter(function (n) { return once(n, 'r'); });
    if (reduce || !items.length) { items.forEach(show); return; }
    if (!io && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting || e.boundingClientRect.top < 0) { show(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0.08 });
    }
    items.forEach(function (n) { pending.push(n); if (io) io.observe(n); });
    if (!swept) {
      swept = true;
      var tick = false;
      window.addEventListener('scroll', function () {
        if (tick) return; tick = true;
        requestAnimationFrame(function () { tick = false; sweep(); });
      }, { passive: true });
      window.addEventListener('resize', sweep);
    }
    sweep();
  }

  /* shop tabs */
  function initTabs(scope) {
    $$('[data-wwl-tabs]', scope).forEach(function (box) {
      if (!once(box, 'tabs')) return;
      var tabs = $$('[role="tab"]', box), sets = $$('[data-set]', box);
      function pick(t, focus) {
        tabs.forEach(function (o) { o.setAttribute('aria-selected', o === t ? 'true' : 'false'); o.tabIndex = o === t ? 0 : -1; });
        sets.forEach(function (s) { s.hidden = s.getAttribute('data-set') !== t.getAttribute('data-tab'); });
        if (focus) t.focus();
      }
      tabs.forEach(function (t, i) {
        t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
        t.addEventListener('click', function () { pick(t); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = null;
          if (k === 'ArrowRight' || k === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
          if (k === 'ArrowLeft' || k === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { e.preventDefault(); pick(n, true); }
        });
      });
      box.wwlPick = pick;
    });
  }

  /* scene: pins and legend rows light each other up */
  function initScene(scope) {
    $$('[data-wwl-scene]', scope).forEach(function (box) {
      if (!once(box, 'scene')) return;
      function set(k, on) {
        $$('[data-k="' + k + '"]', box).forEach(function (n) { n.classList.toggle('is-on', on); });
      }
      $$('[data-k]', box).forEach(function (n) {
        var k = n.getAttribute('data-k');
        n.addEventListener('mouseenter', function () { set(k, true); });
        n.addEventListener('mouseleave', function () { set(k, false); });
        n.addEventListener('focusin', function () { set(k, true); });
        n.addEventListener('focusout', function () { set(k, false); });
        if (n.tagName === 'BUTTON') n.addEventListener('click', function () {
          $$('.is-on', box).forEach(function (o) { o.classList.remove('is-on'); });
          set(k, true);
        });
      });
    });
  }

  /* ticker: exact-pixel rAF loop, never a visible end */
  function initTicker(scope) {
    $$('[data-wwl-ticker]', scope).forEach(function (row) {
      if (!once(row, 'ticker')) return;
      var first = row.children[0]; if (!first) return;
      var need = Math.ceil((window.innerWidth * 2) / Math.max(first.getBoundingClientRect().width, 1)) + 1;
      for (var i = row.children.length; i < need; i++) row.appendChild(first.cloneNode(true)).setAttribute('aria-hidden', 'true');
      if (reduce) return;
      var x = 0, last = 0, speed = parseFloat(row.getAttribute('data-speed')) || 40, w = first.getBoundingClientRect().width;
      window.addEventListener('resize', function () { w = first.getBoundingClientRect().width; });
      doc.addEventListener('visibilitychange', function () { last = 0; });
      function step(t) {
        if (!row.isConnected) return;
        if (last) { x -= speed * Math.min(t - last, 64) / 1000; if (-x >= w) x += w; row.style.transform = 'translate3d(' + x + 'px,0,0)'; }
        last = t; requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }

  /* phone drawer */
  var drawer = null, opener = null;
  function setDrawer(on) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', on);
    drawer.setAttribute('aria-hidden', on ? 'false' : 'true');
    doc.body.style.overflow = on ? 'hidden' : '';
    $$('[data-wwl-open]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
    if (on) { var f = drawer.querySelector('[data-wwl-close].wwl-iconbtn') || drawer.querySelector('a'); if (f) setTimeout(function () { f.focus(); }, 60); }
    else if (opener) { opener.focus(); opener = null; }
  }
  function initDrawer(scope) {
    var d = (scope && scope.querySelector && scope.querySelector('[data-wwl-drawer]')) || doc.querySelector('[data-wwl-drawer]');
    if (!d || !once(d, 'drawer')) return;
    drawer = d;
    $$('[data-wwl-open]').forEach(function (b) { if (once(b, 'open')) b.addEventListener('click', function () { opener = b; setDrawer(true); }); });
    $$('[data-wwl-close], a', d).forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
    d.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('a,button', d).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && doc.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && doc.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  }
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) setDrawer(false); });

  /* footer menus: open columns on desktop, accordions on phones */
  var mq = window.matchMedia('(max-width: 767px)');
  function initFooter(scope) {
    var menus = $$('.wwl-fmenu', scope).filter(function (m) { return once(m, 'fmenu'); });
    if (!menus.length) return;
    function apply() { menus.forEach(function (m) { m.open = !mq.matches; }); }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    menus.forEach(function (m) {
      m.querySelector('summary').addEventListener('click', function (e) { if (!mq.matches) e.preventDefault(); });
    });
  }

  /* cart: [data-wwl-add] adds one of the variant and opens Minimog's cart drawer */
  var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-wwl-add]');
    if (!b || b.classList.contains('is-busy')) return;
    e.preventDefault();
    var card = b.closest('.wwl-card'), link = card && card.querySelector('.wwl-card__link');
    b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true');
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: +b.getAttribute('data-wwl-add'), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        b.classList.add('is-added');
        setTimeout(function () { b.classList.remove('is-added'); }, 1600);
        if (doc.querySelector('m-cart-drawer')) doc.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        else window.location.href = rootUrl + 'cart';
      })
      .catch(function () { if (link) window.location.href = link.href; })
      .then(function () { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); });
  });

  /* PDP phone gallery: native scroll-snap track; arrows, n / N counter and the thumb row follow the scroll; the selected variant's image
     is scrolled into view on 'variant:changed' (Minimog product-info.js) */
  function initGallery(scope) {
    $$('[data-wwl-gal]', scope).forEach(function (g) {
      if (!once(g, 'gal')) return;
      var track = g.querySelector('.wwl-gal__track'), slides = $$('.wwl-gal__slide', g), thumbs = $$('.wwl-gal__thumb', g);
      var n = g.querySelector('[data-wwl-gal-n]'), thumbRow = g.querySelector('.wwl-gal__thumbs'), cur = -1;
      function idx() { var w = slides[0] ? slides[0].getBoundingClientRect().width + 10 : 1; return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w))); }
      function go(i, smooth) {
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
      }
      function mark() {
        var i = idx(); if (i === cur) return; cur = i;
        if (n) n.textContent = i + 1;
        thumbs.forEach(function (t, k) { if (k === i) { t.setAttribute('aria-current', 'true'); if (thumbRow) thumbRow.scrollTo({ left: t.offsetLeft - thumbRow.clientWidth / 2 + t.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' }); } else t.removeAttribute('aria-current'); });
      }
      var raf = 0;
      track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; mark(); }); }, { passive: true });
      var prev = g.querySelector('[data-wwl-gal-prev]'), next = g.querySelector('[data-wwl-gal-next]');
      if (prev) prev.addEventListener('click', function () { go(idx() - 1, true); });
      if (next) next.addEventListener('click', function () { go(idx() + 1, true); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-i'), true); }); });
      function toMedia(id, smooth) { if (!id) return; for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-media-id') === String(id)) { go(i, smooth); return; } }
      doc.addEventListener('variant:changed', function (e) { var v = e.detail && e.detail.variant; if (v && v.featured_media) toMedia(v.featured_media.id, true); });
      var start = g.getAttribute('data-start'); if (start && slides[0] && slides[0].getAttribute('data-media-id') !== start) toMedia(start, false);
      mark();
    });
  }

  /* PDP sticky buy bar: Minimog shows it whenever the main button is not fully in view (also BEFORE you reach it, i.e. on the first phone
     screen). It may only appear after the main button has scrolled ABOVE the viewport → html.wwl-atc-past gates it (wwl-skin.css). */
  function initStickyGate() {
    var btn = doc.querySelector('.m-product-form--main .m-add-to-cart'); if (!btn || !once(btn, 'atc')) return;
    function upd() { root.classList.toggle('wwl-atc-past', btn.getBoundingClientRect().bottom < 0); }
    window.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd); upd();
  }

  function init(scope) {
    scope = scope || doc;
    [initReveal, initTabs, initScene, initTicker, initDrawer, initFooter, initGallery, initStickyGate].forEach(function (fn) {
      try { fn(scope); } catch (err) { if (window.console) console.warn('wwl', err); }
    });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); }); else init(doc);
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
  doc.addEventListener('shopify:section:select', function (e) { $$('.wwl-r', e.target).forEach(show); });
  doc.addEventListener('shopify:block:select', function (e) {
    var s = e.target.closest ? (e.target.closest('.shopify-section') || e.target) : e.target;
    $$('.wwl-r', s).forEach(show);
    var tab = e.target.closest && e.target.closest('[role="tab"]'), box = tab && tab.closest('[data-wwl-tabs]');
    if (box && box.wwlPick) box.wwlPick(tab);
  });
})();
